jQuery(function($) {

  
  $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-0;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });



  /*****************************************************/
    /*********** SWIPER TOP HOME ************/
  /*****************************************************/
  var swiper_homeTop = new Swiper('.slider-hometop-js', {
  
      spaceBetween: 0, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

       pagination: {
        el: '.swiper-bullet-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
    
    });




    /*****************************************************/
    /*********** SWIPER NEXT EVENT ************/
  /*****************************************************/


    var swiper_next_evt = new Swiper('.slider-next-event-js', {
  
      spaceBetween: 50, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      pagination: {
        el: '.swiper-bullet-pagination',
        clickable: true
      },
      
       navigation: {
          nextEl: '.contain_slider_nav_externe .swiper-button-next',
          prevEl: '.contain_slider_nav_externe .swiper-button-prev'
        },
        
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      
 
    });


   

    

     /*****************************************************/
    /*********** SWIPER NEXT ACTION ************/
  /*****************************************************/


    var swiper_next_action = new Swiper('.slider-next-action-js', {
  
      spaceBetween: 50, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      pagination: {
        el: '.swiper-bullet-pagination',
        clickable: true
      },
      
       navigation: {
          nextEl: '.nav-externe-slide-action .swiper-button-next',
          prevEl: '.nav-externe-slide-action .swiper-button-prev'
        },
        
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },

        breakpoints: {
        769: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 1.3,
        },
        2000: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 1.5,
        },
        2800: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 2.2,
        }
      }
      
 
    });



     /*****************************************************/
    /*********** SWIPER NEXT OFFER ************/
  /*****************************************************/


    var swiper_next_offer = new Swiper('.slider-next-offer-js', {
  
      spaceBetween: 50, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      pagination: {
        el: '.swiper-bullet-pagination',
        clickable: true
      },
      
       navigation: {
          nextEl: '.nav-externe-slide-offer .swiper-button-next',
          prevEl: '.nav-externe-slide-offer .swiper-button-prev'
        },
        
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },

      breakpoints: {
        769: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 1.5,
        },
        2000: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 1.8,
        },
        2800: { // a partir de 769
          spaceBetween: 50,
          slidesPerView: 2.7,
        }
      }
      
 
    });




        /*****************************************************/
    /*********** SWIPER SIMPLE GALLERY ************/
  /*****************************************************/


    var swiper_simple_gallery = new Swiper('.slider-simple-gallery-js', {
  
      spaceBetween: 50, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

      pagination: {
        el: '.swiper-bullet-pagination',
        clickable: true
      },
      
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
 
    });



    /*****************************************************/
    /*********** SWIPER GALLERY CONTACT ************/
  /*****************************************************/


    var swiper_gallery_contact = new Swiper('.slider_gallery_contact', {
  
      spaceBetween: 50, // try '5%' if you want
      slidesPerView: 1,
      loop:true,
      speed:1000,

    
      
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },


      breakpoints: {
        1024: { // a partir de 769
          spaceBetween: 18,
          slidesPerView: 2,
        }
      }

 
    });




  /**************************************************************************************/
  /*********************** Flexible MODULE F / Slider de texte (avec titre cliquable) *********************************/
  /**************************************************************************************/

  var menu_pagination_mA = [];
  var titleMASlide = document.querySelectorAll('.swiper-container-mF .mF-TitleMobile');
  titleMASlide.forEach(function (sandwich, index) {
    menu_pagination_mA.push(sandwich.innerHTML);
  });

  var swiper_module_a = new Swiper('.swiper-container-mF', {


    // If we need pagination
      spaceBetween: 16, // try '5%' if you want
      centeredSlides: true,
      slidesPerView: 1.25,
      loop: true,

     pagination: {
           el: '.swiper-bullet-pagination',
           clickable: true
      },

      breakpoints: {
        769: { // a partir de 769

          spaceBetween: 20,
          centeredSlides: false,
          slidesPerView: 1,
          loop: false,

          pagination: {
          el: '.swiper-mF-txt',
          clickable: true,
            renderBullet: function (index, className) {
              return '<span class="button-label ' + className + '"><i class="icon-right" aria-hidden="true"></i> ' + (menu_pagination_mA[index]) + '</span>';
            },
          },
        }
      },
      on: {
      breakpoint: function (swiper) {
        this.update();
      }
    }

  });

  /**************************************************************************************/
  /*********************** FIN MODULE A / Services *********************************/
  /**************************************************************************************/





    /**********************************************************************/
      /*************** AGENDA / PAGINATION  ****************/
    /**********************************************************************/
     if ($(".paginate_evt .pagination__next").length) {
      $('.list-infinite-evt').infiniteScroll({
          path: '.pagination__next',
          append: '.ResumeEvt',
          status: '.page-load-status',
          hideNav: '.pagination__next',
          history:false // ne change pas l'url
      });  
    }


    /**********************************************************************/
      /*************** POST / MASONRY + INFINITE SCROLL  ****************/
    /**********************************************************************/


    let $container = $('.grid-container');
    $container.imagesLoaded(function () {
        $container.masonry({
            itemSelector: '.item-masonry'
        });
    });
    

    $('.grid-container').masonry({
        itemSelector: '.item-masonry',
        columnWidth: '.post-sizer',
        gutter: '.post-gutter-sizer',
        percentPosition: true
    });

    if ($(".paginate_post .pagination__next").length) {
      let msnry = $container.data('masonry');

      $('.list-infinite-post').infiniteScroll({
          path: '.pagination__next',
          append: '.item-masonry',
          status: '.page-load-status',
          hideNav: '.pagination__next',
          outlayer: msnry,
          history:false // ne change pas l'url
         
      }); 
  }



    /**********************************************************************/
      /*************** AGIR - ACTION / MASONRY + INFINITE SCROLL  ****************/
    /**********************************************************************/


     let $container_agir = $('.grid-container-agir');
    $container_agir.imagesLoaded(function () {
        $container_agir.masonry({
            itemSelector: '.item-masonry'
        });
    });
    

    $('.grid-container-agir').masonry({
        itemSelector: '.item-masonry',
        columnWidth: '.agir-sizer',
        gutter: '.agir-gutter-sizer',
        percentPosition: true
    });

    if ($(".paginate_agir .pagination__next").length) {
      let msnry = $container_agir.data('masonry');

      $('.list-infinite-agir').infiniteScroll({
          path: '.pagination__next',
          append: '.item-masonry',
          status: '.page-load-status',
          hideNav: '.pagination__next',
          outlayer: msnry,
          history:false // ne change pas l'url
         
      }); 
  }



    /**********************************************************************/
      /*************** OFFRES ET MISSION -  MASONRY + FILTRE  ****************/
    /**********************************************************************/
    var $grid = $('.js-offers-grid');
    if ($grid.length){

      var $iso = $grid.isotope({
        itemSelector: '.ResumeOffer',
        layoutMode: 'masonry',
        percentPosition: true,
        transitionDuration: '0.35s',
        masonry: {
          columnWidth: '.offer-sizer',
          gutter: '.offer-gutter-sizer',
        }
      });

      $('.js-offers-filters').on('click', '.js-filter-btn', function() {
        var filterValue = $(this).attr('data-filter');

        $('.js-filter-btn').removeClass('is-active');
        $(this).addClass('is-active');

        $('.js-offers-filters .CatDesktopList-Item').removeClass('current');
        $(this).closest('.CatDesktopList-Item').addClass('current');

        $grid.isotope({ filter: filterValue });

          // Vérifie le nombre d'éléments visibles
          var filteredItems = $grid.data('isotope').filteredItems.length;

          if(filteredItems == 0){
              $('.no-results-filter').show();
          } else {
              $('.no-results-filter').hide();
          }

      });

      if ($.fn.imagesLoaded) {
        $grid.imagesLoaded().progress(function() {
          $grid.isotope('layout');
        });
      }
  
    }




      /*********************************/
      /** MASONRY POUR LES OUTILS DANS LA PAGE "BOITE A OUTIL" **/
    /*********************************/
     var $recherche_prog = $('#recherche_prog');
    if ($recherche_prog.length){
  

      $('#recherche_prog button').on('click',function(){
           return false;
      });


    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        this.parentNode.classList.toggle("active_filters");
        // if(this.parentNode.classList.contains('active_filters')){

        // }
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
         /* Masonry Project archive */  
    var $container_project_masonry = $('.outil-resume-listcontainer');

    var grid_isotope;
    var class_filter_init = '*';
    var string_number_filter = document.getElementById('number-filter');
   // if(string_value.type_filter_rea != '*') class_filter_init = '.'+string_value.type_filter_rea;
    $container_project_masonry.imagesLoaded(function () {
        grid_isotope = $container_project_masonry.isotope({
            itemSelector: '.ResumeOutil',
            percentPosition: true,
            filter:class_filter_init,
            masonry: {
                columnWidth: '.tool-sizer',
                gutter: '.tool-gutter-sizer',
            } 
        });
    });

   grid_isotope = $container_project_masonry.isotope({
            itemSelector: '.ResumeOutil',
            percentPosition: true,
            filter:class_filter_init,
            masonry: {
                columnWidth: '.tool-sizer',
                gutter: '.tool-gutter-sizer',
            } 
    });


     // https://codepen.io/desandro/pen/DeGjdQ
    var filters = {};
      // do stuff when checkbox change
    $(".blockFilterAction input[type='checkbox']").on( 'change', function( jQEvent ){
      var $checkbox = $( jQEvent.target );
      manageCheckbox( $checkbox );

      var comboFilter = getComboFilter( filters );
      //console.log(comboFilter);
      grid_isotope.isotope({ filter: comboFilter });
      
      var filteredItems = grid_isotope.isotope('getFilteredItemElements');
      $('.ResumeOutil').removeClass('filter_active');
      filteredItems.forEach(elm => elm.classList.add('filter_active')); 

      string_number_filter.textContent = "("+grid_isotope.data('isotope').filteredItems.length+")";
      var elm = string_number_filter;
      var newone = elm.cloneNode(true);
      string_number_filter = newone;
      elm.parentNode.replaceChild(newone, elm);
    });

  }

     function getComboFilter( filters ) {
    var i = 0;
    var comboFilters = [];
    var message = [];

    for ( var prop in filters ) {
      message.push( filters[ prop ].join(' ') );
      var filterGroup = filters[ prop ];
      // skip to next filter group if it doesn't have any values
      if ( !filterGroup.length ) {
        continue;
      }
      if ( i === 0 ) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        var filterSelectors = [];
        // copy to fresh array
        var groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (var k=0, len3 = filterGroup.length; k < len3; k++) {
          for (var j=0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push( groupCombo[j] + filterGroup[k] ); // [ 1, 2 ]
          }

        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }

    var comboFilter = comboFilters.join(', ');
    return comboFilter;
  }

    function manageCheckbox( $checkbox ) {
      var checkbox = $checkbox[0];

      var group = $checkbox.parents('.option-set').attr('data-group');
      // create array for filter group, if not there yet
      var filterGroup = filters[ group ];
      if ( !filterGroup ) {
        filterGroup = filters[ group ] = [];
      }

      var isAll = $checkbox.hasClass('all');
      // reset filter group if the all box was checked
      if ( isAll ) {
        delete filters[ group ];
       
        if ( !checkbox.checked ) {
          checkbox.checked = 'checked';
        }
      }
      // index of
      var index = $.inArray('.'+checkbox.value, filterGroup );

      if ( checkbox.checked ) {
        var selector = isAll ? 'input.other' : 'input.all';
        $checkbox.parents('.option-set').find( selector ).removeAttr('checked');


        if ( !isAll && index === -1 ) {
          // add filter to group
          filters[ group ].push('.'+checkbox.value );
        }

      } else if ( !isAll ) {
        // remove filter from group
        filters[ group ].splice( index, 1 );
        // if unchecked the last box, check the all
          if ($checkbox.parents('.option-set').find('input:checked').length == 0) {
           $checkbox.parents('.option-set').find('input.all').prop('checked', true);
        }
      }

  }



   /* NICE SELECT / TRIE PAR ASSOS / ACTUS */
    $('.to_nicedropdown-js').niceSelect();




});


